import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Paragraph from "@components/CustomTypography/Paragraph/Paragraph"
import Title from "@components/CustomTypography/Title/Title"
import ButtonComponent from "@components/Theme/Button/Button"
import {translateWithRouter} from "@helpers/translate"

import styles from "./CustomErrorPage.module.scss"

type Props = {
	statusCode: number
}

const CustomErrorPage = (props: Props) => {
	let errorTitle = `${translateWithRouter("Error")} - ${props.statusCode}`
	let errorDescription = "An error occurred on the server."

	if (props.statusCode === 404) {
		errorTitle = `404 - ${translateWithRouter("Page Not Found")}`
		errorDescription = "Sorry, the page you are looking for does not exist."
	}

	return (
		<ContainerWrapper>
			<div className={styles.container}>
				<Title
					className={styles.title}
					content={errorTitle}
					size={"XL"}
					type={"1"}
					capitalize
				/>
				<Paragraph
					className={styles.message}
					content={errorDescription}
					size={"S"}
				/>
				<ButtonComponent
					buttonType={"readMore"}
					className={styles.link}
					link={"/"}
					size={"large"}
					asLink
				>
					Go back to the home page
				</ButtonComponent>
			</div>
		</ContainerWrapper>
	)
}

export default CustomErrorPage
